import React, { useState } from "react";
import { CTA } from "@coverme/forms";
import { CoverMeDropzone } from "../Documents/CoverMeDropzone";
import "../InterviewDocuments/InterviewDocuments.scss";

export const DocumentForm = ({ onSubmit }) => {
    const [uploadedFile, setUploadedFile] = useState([]);
    const [isFormValid, setIsFormValid] = useState(true);

    function submit() {
        if (uploadedFile.length === 0) {
            setIsFormValid(false);
            return;
        } else {
            setIsFormValid(true);
        }
        setIsFormValid(true);
        onSubmit(uploadedFile[0]);
    }

    return (
        <div className="upload-form">
            <CoverMeDropzone
                onFileSelect={setUploadedFile}
                isValid={isFormValid === true || uploadedFile.length > 0}
                errorMessage={"Required"}
                allowedFileExtensions={[".csv"]}
            />
            <div className="submit-button">
                <CTA styleType={"blue"} size="large" disabled={false} ctaType={"button"} click={submit}>
                    Upload
                </CTA>
            </div>
        </div>
    );
};
